import React from "react";

export default function About() {
  return (
    <section id="about">
        <div className="about">
      <h4 className="hero4">About</h4>
      <p className="aboutText">
        In the quick-paced world of today, it's critical to keep your knowledge
        and abilities current. Data Structures and Algorithms (DSA) is one such
        field that has shown tremendous growth in recent years. DSA is a key
        component of computer science and is essential for creating effective
        and optimised software. But learning DSA is not a simple feat. To excel
        in this discipline, a lot of practise and commitment are needed. We have
        created a React-based web application that enables users to follow a DSA
        sheet and track their progress in order to aid people in their journey
        of learning DSA. Any student will enjoy using our web application
        because it is interactive and simple to use.Users may readily access the
        DSA sheet and start practising straight away because to the platform's
        design. The DSA sheet's thorough organisation makes it simple for users
        to move between various themes and concepts.
      </p>
    </div>
    </section>
  );
}
